// @ts-check
import React from 'react';

import FullScreenError from 'components/molecules/FullScreenError';
import Actions from 'components/standard/HostingDetailsActions';
import Attributes from 'components/standard/HostingDetailsAttributes';
import PageLayout, {
	PageLayoutInsetContent,
} from 'components/standard/PageLayout';
import hostingDetailsAlsowith from 'containers/pages/servers/details/hostingDetailsAlsowith';
import useAssetDetails from 'modules/queries/asset/useDetails';
import NotFound from 'pages/error/NotFound';
import { Redirect, useParams } from 'react-router-dom';
import { getErrorStringHelper } from 'utility/redux/selectorHelperFunctions/apiModules';

/** @typedef {import('@liquidweb-dev/undercurrent').Theme['palette']} Palette */

/**
 * A layout for the BeyondHosting server details pages.
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
const BeyondHostingLayout = ({ children }) => {
	/** @type {{uniqId: string}} */
	const { uniqId } = useParams();

	const {
		data: assetDetailsData,
		isLoading: assetDetailsIsLoading,
		isError: assetDetailsIsError,
		error: assetDetailsError,
	} = useAssetDetails(
		{
			uniq_id: uniqId,
			alsowith: hostingDetailsAlsowith,
		},
		{
			refetchInterval: 30000,
		},
	);

	if (assetDetailsIsError && assetDetailsError.statusCode === 404) {
		return <NotFound />;
	}

	if (assetDetailsIsError) {
		return (
			<FullScreenError content={getErrorStringHelper(assetDetailsIsError)} />
		);
	}

	const { domain, isBeyondHosting } = assetDetailsData || {};

	// redirect non BeyondHosting servers
	if (isBeyondHosting === false) {
		return <Redirect to={`/servers/${uniqId}`} />;
	}

	return (
		<PageLayout
			title={domain || ''}
			attributesSlot={<Attributes />}
			actionsSlot={<Actions />}
			isLoading={assetDetailsIsLoading}
			variant="dynamic"
		>
			<PageLayoutInsetContent sx={{ flexGrow: 1 }}>
				{children}
			</PageLayoutInsetContent>
		</PageLayout>
	);
};

export default BeyondHostingLayout;
